
//import logo from '../images/appiconimage.png';
import AppIcon from '../images/appiconwhite.png';
import "./LogoBanner.css";
import Navbar from './NavBar';

const LogoBanner = () => {  
    return (
        <div className="logo-banner">
            
            <div className="logo-container">
                <img src={AppIcon} className="logo-image" alt="logo" />
            
                <h1 className="logo-text">FactSense</h1>
                <Navbar />
            </div>
        </div>
    );
}
  

export default LogoBanner;